<!--
2022-07-19 HHY 各游戏类锦标赛活动支持
2022-08-03 HHY 增加，用于监听数据变化，取代在mounted中调用verifyIfJoined()
2022-08-05 HHY 增加样式，使排行用户名过长时结尾显示省略号
2022-10-13 Matt 从Promotion跳转进来是SessionStorage中没有保存选中的比赛 https://trello.com/c/nT29p8dK
-->
<template>
  <div class="page-container">
    <GameIframe :gameInfo="gameInfo" :play="playGame" v-if="playGame"/>
    <TopBack :title="activityName" style="margin-top: 66px;"/>
    <div style="margin-top: 10px">
        <img :src="bannerImage" class="header-image" />
    </div>
    <div class="nav">
      <div class="nav-item" :class="{active: type==='rank'}" @click="type = 'rank'">{{$t('lang.gameCompetition.ranking')}}</div>
      <div class="nav-item" :class="{active: type==='rules'}" @click="type = 'rules'">{{$t('lang.gameCompetition.howToPlay')}}</div>
    </div>
    <div class="tab" v-show="type==='rank'">
      <div class="rank-item">
        <div class="rank-no">
          <span>Rank</span>
        </div>
        <div class="rank-content" style="background: none">
          <div class="rank-username-title">
            <span>Name</span>
          </div>
          <div class="rank-splitter" style="border: none"></div>
          <div class="rank-score" style="padding-left: 20px;">
            <span>Score</span>
          </div>
          <div class="rank-reward" style="text-align: center">
            <span style="margin: 0 auto">Rewards</span>
          </div>
        </div>
      </div>
      <Loadmore
        class="load-more-data"
        :bottomPullText="$t('lang.loadingStatus.pullToLoad')"
        :bottomDropText="$t('lang.loadingStatus.releaseToLoad')"
        :bottomLoadingText="$t('lang.loadingStatus.loading')"
        :auto-fill="true"
        :bottom-method="getData"
        :bottom-all-loaded="hasLoadAll"
        ref="loadmore">
        <div v-for="(item, index) in rankList"
             :key="index" class="rank-item">
          <div class="rank-no" :style="{backgroundImage: 'url(' + nobg + ')'}">
            <span>{{item.Rank}}</span>
          </div>
          <div class="rank-content">
            <div class="rank-username">
              <span>{{item.UserName}}</span>
            </div>
            <div class="rank-splitter"></div>
            <div class="rank-score">
              <div class="score">
                <span>{{item.UserScore}}</span>
              </div>
              <div class="icon">
                <img :src="up" v-if="item.RankTrend > 0">
                <img :src="down" v-if="item.RankTrend < 0">
              </div>
            </div>
            <div class="rank-reward">
              <div class="score">
                <span>{{item.Reward}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="showMore" v-if="!hasLoadAll"><img :src="showMore" alt=""></div>
      </Loadmore>

      <div class="rank-splitter"></div>
      <div class="my-rank">
        <div class="rank-item" v-if="userInfo && userInfo.UserId">
          <div class="rank-no" :style="{backgroundImage: 'url(' + nobg + ')'}">
            <span>{{myRank.Rank>0 ? myRank.Rank : '?'}}</span>
          </div>
          <div class="rank-content">
            <div class="rank-username">
              <span>{{myRank.UserName}}</span>
            </div>
            <div class="rank-splitter"></div>
            <div class="rank-score">
              <div class="score">
                <span>{{myRank.UserScore > 0 ? myRank.UserScore : '-'}}</span>
              </div>
              <div class="icon">
                <img :src="up" v-if="myRank.RankTrend > 0">
                <img :src="down" v-if="myRank.RankTrend < 0">
              </div>
            </div>
            <div class="rank-reward">
              <div class="score">
                <span>{{myRank.Reward}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab rules" v-show="type==='rules'">
      <div v-for="(item, index) in $t('lang.gameCompetition.rules')"
           :key="index">
        <div class="rule-item">
          <div class="rule-number">
            <span>{{index+1}}</span>
          </div>
          <div class="rule-content">
            <div class="rule-title">
              <span v-html="item"></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="play-btn" v-if="showJoinIn"
        :class="{playbtndisable: this.playButtonEanbled === false}"
         @click="joinInActivity()">
      <span>{{$t('lang.common.joinin')}}</span>
    </div>
    <div class="play-btn" v-if="!showJoinIn"
        :class="{playbtndisable: this.playButtonEanbled === false}"
         @click="joinInActivity()">
      <span>{{$t('lang.common.play')}}</span>
    </div>
  </div>
</template>

<script>
// import store from '../../store/store'
import andar from '@/assets/images/gamecompetition/andartornament.png'
import nobg from '@/assets/images/gamecompetition/nobg.png'
import up from '@/assets/images/gamecompetition/up.png'
import down from '@/assets/images/gamecompetition/down.png'
import {Loadmore, Toast} from 'mint-ui'
import request from '@/service'
import showMore from '@/assets/images/common/showMore.gif'
import TopBack from '@/components/TopBack/index'
import GameIframe from '@/components/GameIframe/index'

export default {
  name: 'GameCompetition1',
  components: {
    TopBack,
    Loadmore,
    GameIframe
  },
  data () {
    return {
      andar,
      nobg,
      up,
      down,
      showMore,
      type: 'rank',
      rankList: [],
      myRank: {},
      userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
      hasLoadAll: false,
      activityCode: '',
      activityName: '',
      gameCode: '',
      gameProviderId: '',
      gameName: '',
      gameImg: '',
      playGame: false,
      playVideo: false,
      gameInfo: {},
      showJoinIn: true, // by HHY 20220605
      playButtonEanbled: true, // by HHY 20220621
      gameCategory: '',
      defaultTournament: {}
    }
  },
  computed: {
    comeFromTournament: {
      cache: false,
      get: function () {
        return sessionStorage.getItem('comeFromTournament')
      }
    },
    bannerImage: {
      cache: false,
      get: function () {
        return sessionStorage.getItem('SelectedActivityBanner') || this.defaultTournament.BannerImage
      }
    }
  },
  mounted () {
    // this.verifyIfJoined() // by HHY 20220605
    // this.getData()
    this.getDefaultTournament()
  },
  methods: {
    getData () {
      const selectedActivity = JSON.parse(sessionStorage.getItem('selectedActivity')) || this.defaultTournament
      const data = {
        UserId: this.userInfo.UserId,
        ActivityCode: selectedActivity.activityCode,
        LastRank: this.rankList.length > 0 ? this.rankList[this.rankList.length - 1].Rank : 0,
        internation: this.$store.state.internation
      }
      request('post', '/innovation/game/getactivityresult', data)
        .then(res => {
          if (res.Results) {
            this.rankList = this.rankList.concat(res.Results)
          }
          if (res.MyRank) {
            this.myRank = res.MyRank
          }
          this.activityName = res.ActivityName
          this.gameCode = res.GameCode
          this.gameProviderId = res.GameProviderId
          this.gameName = res.GameName
          this.gameImg = res.GameImage
          if (res.Results && res.Results.length === 0) {
            this.hasLoadAll = true
          } else {
            this.hasLoadAll = false
          }

          if (!this.firstLoad) {
            this.$refs.loadmore.onBottomLoaded()
          }
          this.firstLoad = false
        })
    },
    getDefaultTournament () {
      const url = 'innovation/activity/getgameactivitycategoryinfo'
      const data = {
        internation: this.$store.state.internation
      }
      request('post', url, data, true).then(tournaments => {
        tournaments.sort((a, b) => a.OrderNo - b.OrderNo)
        this.defaultTournament = tournaments[0]
      }).catch(err => {
        console.log(err)
      })
    },
    fetchGame (gameCode, gameProviderId, gameImg, gameNameEn) {
      if (!this.playButtonEanbled) { // 提示游戏已结束
        // Toast(this.$t('lang.home.activityOver'))
        return
      }
      if (this.userInfo) {
        if (this.$store.state.banUserId.includes(this.userInfo.UserId)) {
          Toast(this.$t('lang.home.gameMaintenancePrompt'))
          return
        }
        const url = '/innovation/game/getgameurl'
        const data = {
          userId: this.userInfo.UserId || '',
          gameCode: gameCode,
          gameProviderId: gameProviderId,
          deviceWidth: document.body.clientWidth,
          lang: localStorage.getItem('locale')
        }
        request('post', url, data).then(res => {
          if (res.Url) {
            this.gameInfo = {
              gameUrl: res.Url,
              gameImg: gameImg,
              gameName: gameNameEn
            }
            this.showGame = true
            this.playGame = true
          } else {
            Toast(this.$t('lang.home.gameMaintenancePrompt'))
          }
        }).catch(err => {
          console.log(err)
          Toast(Toast(this.$t('lang.home.gameMaintenancePrompt')))
        })
      } else {
        this.$router.push('/Login')
      }
    },
    close () {
      this.playGame = false
    },
    verifyIfJoined () { // 先判断用户是否已在外部用户表，若在，直接显示PLAY按钮 by HHY 20220605
      const url = '/innovation/game/verifyifshowjoinin'
      var selectedActivity = JSON.parse(sessionStorage.getItem('selectedActivity'))
      const data = {
        UserId: this.userInfo.UserId || '',
        ActivityCode: selectedActivity.activityCode
      }
      request('post', url, data).then(res => {
        this.showJoinIn = res.showjoin
        this.playButtonEanbled = res.isEnabled
        this.getData()
      })
    },
    joinInActivity () { // 如果外部用户点击JOIN IN按钮，就会被记录到外部用户表 by HHY 20220605
      if (!this.playButtonEanbled) { // 提示游戏已结束
        Toast(this.$t('lang.home.activityOver'))
        return
      }
      if (this.userInfo.UserId === undefined) {
        sessionStorage.setItem('comeFromTournament', '1')
        this.$router.push('/Login')
      } else {
        if (this.showJoinIn) {
          const url = '/innovation/game/joingameactivity'
          const selectedActivity = JSON.parse(sessionStorage.getItem('selectedActivity')) || this.defaultTournament
          const data = {
            UserId: this.userInfo.UserId || '',
            ActivityCode: selectedActivity.activityCode
          }
          request('post', url, data).then(res => {
            this.showJoinIn = res.showjoin
            sessionStorage.setItem('comeFromTournament', '1')
            this.$router.push({path: '/Home'}) // 点击JOININ按钮跳转到具体游戏类页面 HHY 2022-07-20
          })
        } else {
          sessionStorage.setItem('comeFromTournament', '1')
          this.$router.push({path: '/Home'})
        }
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.activityCode = to.query.activityCode
      // vm.gameCategory = to.query.category
    })
  },
  watch: {
    'comeFromTournament': { // 2022-08-03 HHY 增加，用于监听数据变化，取代在mounted中调用verifyIfJoined()
      handler (newData, oldData) {
        console.log('competeactivated0')
        if (this.comeFromTournament === '0') {
          console.log('competeactivated1')
          this.verifyIfJoined()
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style scoped lang="less" >
  .page-container{
    position: absolute;

    .header-image{
      width: 100%;
      display: block;
    }

    .nav{
      display: flex;
      margin: 15px 10px 20px 10px;
      border-radius: 6px;
      border: 1px solid rgba(246, 217,170, 0.5);

      .nav-item{
        flex: 1;
        line-height: 30px;
        text-align: center;
      }

      .active{
        background: #F6D9AA;
        color: #543200;
        border-radius: 6px;
      }
    }

    .load-more-data {
      max-height: calc(50vh - 65px);
      overflow: scroll;
      padding-bottom: 60px;
    }

    .rank-item {
      margin: 5px 10px;
      display: flex;
      line-height: 25px;

      .rank-no {
        width: 25px;
        height: 25px;
        background-size: contain;
        text-align: center;
        color: #FFFFFF;
      }

      .rank-content {
        background: rgba(237, 185, 5, 0.2);
        margin: 0 0 0 20px;
        width: calc(100vw - 20px - 25px - 20px);
        border-radius: 52px;
        display: flex;

        .rank-username-title {
          width: calc(100vw - 20px - 25px - 20px - 150px - 1px);
          color: #FFFFFF;
          font-size: 14px;
          display: flex;
          justify-content: center;
        }

        .rank-username {
          width: calc(100vw - 20px - 25px - 20px - 150px - 1px);
          padding: 0 15px;
          color: #FFFFFF;
          font-size: 14px;
          word-break:keep-all; // 不换行
          white-space:nowrap; // 不换行
          overflow:hidden; // 内容超出宽度时隐藏超出部分的内容
          text-overflow:ellipsis; // 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用 2022-08005 HHY 增加
        }

        .rank-splitter {
          width: 1px;
          border-right: 1px solid #F6D9AA;
          margin: 3px 0px;
        }

        .rank-score {
          width: 150px;
          text-align: center;
          color: #FFFFFF;
          font-size: 14px;
          display: flex;

          .score{
            width: 80px;
            text-align: center;
          }

          .icon{
            width: 20px;
            padding: 0 10px 0 0;

            img{
              width: 7px;
              margin: 0 auto;
            }
          }
        }
       .rank-reward {
          width: 100px;
          text-align: center;
          color: #FFFFFF;
          font-size: 14px;
          display: flex;

          .score{
            width: 80px;
            text-align: center;
          }
        }
      }
    }

    .rank-splitter {
      margin: 15px 10px 15px 10px;
      border-bottom: 1px solid #FFFFFF;
    }

    .rules{
      margin: 0px 10px 0px 10px;
      max-height: 50vh;
      overflow: scroll;
      padding-bottom: 30px;

      .rule-item{
        display: flex;
        margin-bottom: 10px;
        .rule-number{
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 1px solid #F6D9AA;
          text-align: center;
          line-height: 40px;
          font-size: 20px;
          color: #F6D9AA;
        }
        .rule-content{
          width: calc(100vw - 32px - 40px);
          padding: 0 0px 0 10px;
          .rule-title{
            color: #F6D9AA;
            font-size: 16px;
            line-height: 20px;
            margin: 0 0 5px 0;
          }
          .rule-description{
            color: #DADADA;
            font-size: 14px;
            line-height: 20px;
          }
        }
      }
    }

    .my-rank {
      position: fixed;
      bottom: 64px;
      background: #161616;
      padding-top: 12px;
    }

    .play-btn{
      position: fixed;
      bottom: 0;
      width: 94%;
      background: #F6D9AA;
      border-radius: 6px;
      line-height: 20px;
      padding: 12px 0px;
      text-align: center;
      color: #000D2E;
      font-size: 20px;
      margin: 30px 10px 12px 10px;
    }

    .playbtndisable{
      background: #747474;
    }

    .showMore {
      text-align: center;
      img {
        width: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/GameCompetition/competition3.vue